
<template>
    <!--    <TitleCard :titleMsg1="titleMsg1" :titleMsg2="titleMsg2" :titleMsg3="titleMsg3"></TitleCard>-->

    <div class="all-card-style" >
        <a-row :gutter="16" style="display: flex;align-items: stretch;">
        <a-col :span="6" flex="auto"  >
          <a-card class="el-img-box-style">
            <img src="../../../image/homePage/guangai.png" alt="" class="el-img-style">
          </a-card>
        </a-col>
        <a-col  :span="18" flex="auto">
          <a-row :gutter="16">


            <a-col :span="12">
              <a-card style="background-color:#0A2D57;border-bottom:1px soild #ffffff;" title="设备概况" >
                <div slot="extra" class="white">更新于：{{lastDeviceTime}}</div>
                <div id="bing1">
                  <!--   <div style="height:153px;margin-top:29px">
                     <img  src="../../../image/table1 (1).png" style="height:135px;width:314px;margin-left:26%" />
                     </div>-->
                </div>

              </a-card>
            </a-col>

            <a-col :span="12">
              <a-card style="background-color:#0A2D57;border-color:#0A2D57;" title="报警概况">
                <div slot="extra" class="white" >更新于：{{lastEventTime}}</div>
                <div id="bing2">
                  <!--     <div style="height:153px;margin-top:29px">
                      <img  src="../../../image/table1 (3).png" style="height:135px;width:314px;margin-left:26%" />
                       </div>-->
                </div>
              </a-card>
            </a-col>


          </a-row>
          <a-card class="equipment-table-card-style "  style="background-color:#0A2D57;border-style:none;margin-top:20px;">
            <!--      搜索模块-->
            <div class="search-box" >
              <a-form layout="inline"  >

                <a-form-item style="background-color:#0A2D57;"
                             label="设备编号" class="ant-form-item2"
                >
                  <a-input
                    placeholder="请输入" v-model="queryInfo.keyword"
                  >
                    <a-icon slot="prefix" type="search" style="color:rgba(0,0,0,.25)" />
                  </a-input>
                </a-form-item>
                <a-form-item
                  label="设备名称" class="ant-form-item2"
                >
                  <a-input
                    placeholder="请输入" v-model="queryInfo.DeviceName"
                  >
                    <a-icon slot="prefix" type="search" style="color:rgba(0,0,0,.25)" />
                  </a-input>
                </a-form-item>


                <a-form-item>
                  <a-button type="primary"  @click="getDevices">
                    查询
                  </a-button>
                </a-form-item>
              </a-form>
            </div>
            <!--      列表表格-->
            <!-- <div style="background-color:#0A2D57;">
              <a-table :pagination="pagination" @change="handleTableChange" :columns="columns" :data-source="data"  style="background-color:#0A2D57;">
          <span slot="action"   slot-scope="text, record"  style="background-color:#0A2D57;">
            <a @click="toEDPage(record.IotId)">详情</a>
          </span>
              </a-table>
            </div> -->
            <div >
              <a-table :pagination="pagination" @change="handleTableChange" :columns="columns" :data-source="data">
          <span slot="action"   slot-scope="text, record">
            <a @click="toEDPage(record.IotId)">详情</a>
          </span>
              </a-table>
            </div>
          </a-card>
        </a-col>
      </a-row>
    </div>

</template>

<script>
  // @ is an alias to /src
  import TitleCard from '@/components/TitleCard.vue'
  import { Chart } from '@antv/g2';
  import { _getDeviceEventData } from '@/common/request'

  const columns = [

    {
      title: '设备名称',
      dataIndex: 'DeviceName',
      key: 'DeviceName',
      ellipsis: true,
    },
    {
      title: '设备别名',
      dataIndex: 'DeviceAsName',
      key: 'DeviceAsName',
      ellipsis: true,
    },
    {
      title: '所属产品',
      dataIndex: 'ProductName',
      key: 'ProductName',
      ellipsis: true,
    },
    {
      title: '所属平台',
      dataIndex: 'cPlatformName',
      key: 'cPlatformName',
      ellipsis: true,
    },
    {
      title: '所属场景',
      dataIndex: 'cSceneName',
      key: 'cSceneName',
      ellipsis: true,
    },
    {
      title: '地点',
      dataIndex: 'cAddress',
      key: 'cAddress',
      ellipsis: true,
    },
    {
      title: '负责人',
      dataIndex: 'cCreateUserName',
      key: 'cCreateUserName  ',
    },
    {
      title: '创建时间',
      dataIndex: 'dCreateDate',
      key: 'dCreateDate',
      ellipsis: true,
    },
    {
      title: '操作',
      key: 'action',
      scopedSlots: { customRender: 'action' },
    },
  ];



  export default {
    name: 'equipmentList',
    components: {
      TitleCard
    },
    data() {
      return {
        titleMsg1: "设备管理",
        titleMsg2:'设备列表',
        titleMsg3:'设备列表',
        data:[],
        resdata:null,
        eventData:[],
        neweventData:[],
        lastchart1:null,
        lastchart2:null,
        statusData:[],
        columns,
        cPlatformID:0,//平台编号


        sceneformSelectItems:[],
        queryInfo:{
          productkey:"",
          keyword:"",
          deviceId:'',
          devicename:'',
          sceneId:'',
          page:1,
          limit:10,
          cEntID:''
        },
        lastDeviceTime:'',
        lastEventTime:'',
        pagination: {
          current:1,
          total: 0,
          pageSize: 10,//每页中显示10条数据
          showSizeChanger: true,
          pageSizeOptions: ["10", "20", "50", "100"],//每页中显示的数据
          showTotal: total => `共有 ${total} 条数据`,  //分页中显示总的数据
        },
      }
    },
    created(){


    },
    mounted() {
      let that=this;
      var ThingModels=that.utils.deepClone(that.$store.getters.ThingModels);
//console.log('ThingModels',ThingModels)
      ThingModels.forEach((ele,index)=>{
        if (ele){
          //  console.log('ele.events',ele.events)
          //   if(!!ele.events&&ele.events.length>0)
          that.eventData=that.eventData.concat(ele.events)

        }
      })

      that.queryInfo.cEntID=that.$store.getters.User.enterprise.ID;
      that.queryInfo.sceneId=that.$store.getters.SCene.ID;
      that.$bus.$on('scenechange',(target)=> {
        that.queryInfo.sceneId=target.id;
        that.getDevices();
        that.createBing1()
    //    that.rendereventsdata();
      });
      console.log(' that.queryInfo.sceneId that.queryInfo.sceneId that.queryInfo.sceneId', that.queryInfo.sceneId)
      that.getDevices();
      that.createBing1()
 //     that.rendereventsdata();
    },
    methods: {
      toEDPage: function (IotId) {
        this.$router.push({
          path: '/equipment/equipmentDetails',
          query: {
            IotId: IotId
          }
        })
      },
      handleTableChange (pagination) {
        this.pagination.current = pagination.current;
        this.pagination.pageSize = pagination.pageSize;
        this.queryInfo.page = pagination.current;
        this.queryInfo.limit = pagination.pageSize;
        this.getDevices();
      },
      async rendereventsdata(){
        let that=this;

        let devicenames='';
        console.log(' that.statusData', that.statusData);
        that.statusData.forEach((ele,index)=>{
          devicenames+="'"+ele.DeviceName+"',";
        });


        if (devicenames){
          devicenames=devicenames.substr(0,devicenames.length-1);
        }

        if (devicenames)
        {

          let res2=await _getDeviceEventData(that,{deviceName:devicenames});

          if (res2.code=="200" ) {
            that.resdata = res2.obj.list;
          }else {
            that.resdata=[];
          }
          console.log(123123123)
          that.createBing2();

        }else {

          console.log(321321321)
          that.createBing2();
        }

      },
      async getDevices () {
        var _this = this
        _this.queryInfo.cSystemCode='节水灌溉';
        let res = await _this.$http.post('WLWDevice/PageList', _this.queryInfo)

        if (res.data.code == 200) {
          _this.data = res.data.obj.list

          _this.pagination.total = res.data.obj.listTotal

        }
      },

      toAddPage () {
        this.$router.push({ path: '/equipment/equipmentDetails' });
      },

      async createBing1 () {
        var _this = this
        let res = await _this.$http.post('WLWDevice/List', {
          sceneId: _this.queryInfo.sceneId,cSystemCode:'节水灌溉',
          cEntID: _this.queryInfo.cEntID
        })
       console.log('123res:::',res);
      _this.statusData=res.data.obj.list;
     //   _this.statusData= _this.$store.getters.Devices.filter(s=>s.cSceneID==_this.queryInfo.sceneId&&s.cEntID==_this.queryInfo.cEntID)

        if (this.statusData && this.statusData.length > 0) {
          let timedata = [];
          _this.statusData.map(s => {
            timedata.push(s.GmtOnlineDes)
          });
          this.lastDeviceTime = timedata.reduce(function (a, b) {
            return b > a ? b : a;

          });

        }


        let onlinecount = this.statusData.filter(x => x.Status == "ONLINE") ? this.statusData.filter(x => x.Status == "ONLINE").length : 0

        let offlinecount = this.statusData.filter(x => x.Status == "OFFLINE") ? this.statusData.filter(x => x.Status == "OFFLINE").length : 0

        var totalcount = onlinecount + offlinecount;

        const data = [
          {
            item: '在线设备',
            count: onlinecount,
            textStyle:{
              fill:'#ffffff'
            },

            percent: _this.utils.formatNumber(totalcount == 0 ? 0 : (onlinecount ))
          },
          {
            item: '离线设备',
            count: offlinecount,
            percent: _this.utils.formatNumber(totalcount == 0 ? 0 : (offlinecount ))
          },

        ];

        if (data) {
          let oldchart=_this.$store.getters.DeviceChart;
          _this.$store.commit('setDeviceChart',{});

          if(oldchart&&Object.prototype.hasOwnProperty.call(oldchart, "destroyed"))
          {
            oldchart.destroy();
          }
          const chart = new Chart({
            container: 'bing1',
            autoFit: true,
            height: 210,
          });
          chart.data(data);
          chart.scale('number', {
            formatter: (val) => {
              val = val  + '台';
              return val;
            },
          });
          chart.legend({
            itemName:{
              style: {
                fill: '#ffffff'
              }}
          });


          chart.coordinate('theta', {
            radius: 0.75,
            innerRadius: 0.6,
          });
          chart.tooltip({
            showTitle: true,
            showMarkers: false,
            itemTpl: '<li class="g2-tooltip-list-item"><span style="background-color:{color};" class="g2-tooltip-marker"></span>{name}: {value}</li>',
          });
          // 辅助文本
          chart
            .annotation()
           .text({
              position: ['50%', '50%'],
              content: '设备',
              style: {
                fontSize: 14,
                fill: '#ffffff',
                shadowBlur:1,
                stroke:0,
                textAlign: 'center',
              },
              offsetY: -20,
            })
            .text({
              position: ['50%', '50%'],
              content: totalcount,
              style: {
                fontSize: 14,
                fill: '#ffffff',
                shadowBlur:1,             stroke:0,
                textAlign: 'center',
              },
              offsetX: -10,
              offsetY: 20,
            })
            .text({
              position: ['50%', '50%'],
              content: '台',
              style: {
                fontSize: 14,
                fill: '#ffffff',
                shadowBlur:1,             stroke:0,
                textAlign: 'center',
              },
              offsetY: 20,
              offsetX: 20,
            });
          chart
            .interval()
            .adjust('stack')
            .position('percent')
            .color('item')



            .label('percent', (percent) => {
            return {
              style: {
                fill: '#fff',
              },
              content: (data) => {

               return `${data.item}: ${percent}台`;
             },
        };
          })

       //    .label('percent', {
       //   htmlTemplate: (text, item, index) => {
          // / const point = item.point; // 每个弧度对应的点
         //   let percent = point['percent'];
           // return '<span class="title" style="display: inline-block;width: 50px;">' + item + '</span><br><span style="color:#ffffff">' + percent + '</span>'; // 自定义 html 模板
          //    }
          //  })

            .tooltip('item*percent', (item, percent) => {
              percent = percent  + '台';
              return {
                name: item,
                value: percent,
              };
            });

          chart.interaction('element-active');

          chart.render();

          _this.$store.commit('setDeviceChart',chart);
        }
        _this.   rendereventsdata();
      },


      async  createBing2(){
        let that=this;




        var arr=[];


        let datas= that.resdata;
        console.log('datas',datas);
        that.neweventData=[];
        if (datas&&datas.length>0){
          console.log('   that.eventData',   that.eventData);
          console.log('   that.resdata',   that.resdata);
          that.eventData.forEach(element => {

            if (element){


              var dataItems =that.resdata.filter(x => x.identifier == element.identifier)

              if (dataItems != null && dataItems.length > 0) {
                var dataItem = dataItems[0].values

                element.outputData.forEach(elementItem => {

                  this.$set(elementItem, "name", elementItem.name)
                  this.$set(elementItem, "timeDes", dataItems[0].timeDes)
                })
              } else {
                element.outputData.forEach(elementItem => {
                  this.$set(elementItem, "name", "错误信息")
                  this.$set(elementItem, "timeDes", "")
                })
              }
            }

          })

          that.eventData.forEach((ele,index)=>{

            if (ele){
              that.neweventData= that.neweventData.concat(ele.outputData)
            }
          })


        }else {
          that.neweventData=[];
        }


        if (that.neweventData&&that.neweventData.length>0){
          let timedata=[];
          that.neweventData.map(s=>{timedata.push(s.timeDes)});
          this.lastEventTime= timedata.reduce(function (a,b) {
            return   b>a?b:a;

          });
        }


        arr=that.neweventData;
        var map = {}, dest = [];
        if (arr){
          for(var i = 0; i < arr.length; i++) {
            var ai = arr[i];
            if(!map[ai.name]) { //依赖分组

              dest.push({
                name: ai.name, //依赖分组
                data: [ai]
              });
              map[ai.name] = ai; //依赖分组
            } else {
              for(var j = 0; j < dest.length; j++) {
                var dj = dest[j];
                if(dj.name== ai.name) { //依赖分组
                  dj.data.push(ai);
                  break;
                }
              }
            }
          }
        }

        let total=0;
        if (dest){
          dest.forEach((ele,index)=>{
            if(ele.data){
              total+=ele.data.length;
            }

          });
        }


        let data = [
        ];

        if (dest){
          dest.forEach((ele,index)=>{
            data.push({
              item:ele.name,
              count:ele.data.length,
              percent: that.utils.formatNumber(ele.data.length!=0?(ele.data.length/total):0)
            });

          });
        }

        if (data){
          let oldevent=that.$store.getters.EventChart;
          that.$store.commit('setEventChart',{});
          if (oldevent&&Object.prototype.hasOwnProperty.call(oldevent, "destroyed")){
            oldevent.destroy();
          }
          const chart = new Chart({
            container: 'bing2',
            autoFit: true,
            height: 210,
          });
          chart.data(data);
          chart.scale('percent', {
            formatter: (val) => {
              val = val  + '次';
              return val;
            },
          });
          chart.coordinate('theta', {
            radius: 0.75,
            innerRadius: 0.6,
          });
          chart.legend({
            itemName:{
              style: {
                fill: '#ffffff'
              }}
          });
          chart.tooltip({
            showTitle: true,
            showMarkers: false,
            itemTpl: '<li class="g2-tooltip-list-item"><span style="background-color:{color};" class="g2-tooltip-marker"></span>{name}: {value}</li>',
          });
          // 辅助文本
          chart
            .annotation()
           .text({
              position: ['50%', '50%'],
              content: '报警',

              style: {
                fontSize: 14,
                fontWeight:'normal',
                fill: '#ffffff',  stroke:0,
                textAlign: 'center',
              },
              offsetY: -20,
            })
            .text({
              position: ['50%', '50%'],
              content: total,
              style: {
                fontSize: 14,       fontWeight:'normal',
                fill: '#ffffff',  stroke:0,
                textAlign: 'center',
              },
              offsetX: -10,
              offsetY: 20,
            })
            .text({
              position: ['50%', '50%'],
              content: '次',
              style: {
                fontSize: 14,  fontWeight:'normal',
                fill: '#ffffff',  stroke:0,
                textAlign: 'center',
              },
              offsetY: 20,
              offsetX: 20,
            });
          chart
            .interval()
            .adjust('stack')
            .position('percent')
            .color('item')
            .label('number', (percent) => {
              return {

                style: {
                  fill: '#fff',
                },
                content: (data) => {

                  return `${data.item}: ${percent }次`;
                },
              };
            })
            .tooltip('item*percent', (item, percent) => {
              percent = percent  + '次';
              return {
                name: item,
                value: percent,
              };
            });

          chart.interaction('element-active');
          chart.render();
          that.$store.commit('setEventChart',chart);
        }



      }


    }


  }


</script>

<style scoped>

  .el-img-style{
    width: 100%
  }

  .el-img-box-style{
    padding-top: 10%;
    padding-bottom: 25%;
    height: 100%;
    background-color:#0A2D57;
    border-style: none;
    color: #ffffff;

  }
  .all-card-style{
    color: #ffffff ;
    width: 100vw;

  }


</style>
<style>
  .white{
    color:white;
  }
</style>
